module.exports = __webpack_public_path__ + "img/Noctiluca-Inspect-Large.65bdbb97.png";